import home from './en/home'
import aboutUs from './en/about_us'
import serv from './en/services'
import contact from './en/contact'
import works from './en/portfolio'
import solve from './en/solutions'
import blog from './en/blog'
import general from './en/general'

export default {
  general,
  home,
  aboutUs,
  serv,
  contact,
  works,
  solve,
  blog,
  utils: {
    back: 'Back'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en.js